<template>
    <div class="rms-logo h-full flex flex-col flex-nowrap justify-center items-center">
        <img src="/assets/images/logos/EZRackLogo.svg" alt="EZRack" />
    </div>
</template>

<script>
export default {
    name: "EZRackLogo",
    setup() {
        return {}
    },
}
</script>
<style>
main section.h-full div.w-full {
    height: 90%;
}
.rms-logo > img {
    width: 50%;
}
</style>
